import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Form, Modal, Spin, Input, Row, Col, Select, DatePicker, message, notification } from 'antd'
import { getExamDictData, getExamPositionTemplate, getExamClass, createExamPosition, updateExamPosition } from '../../../../common/request'
import ResponseCode from '../../../../common/response-code'
import { positionFieldTypeMap } from '../../../../common/common'
import { useDispatch, useSelector } from 'react-redux'

import { updatePositionDic } from '../../../../store/slice/position-dict-slice'
import RegionFormField from '../../../examinee-management/RegionFormField'
import TreeDataFormField from '../../../examinee-management/TreeDataFormField'

const HIDDEN_POSITION_FIELD_CODES = ['siteId', 'siteCode', 'levelCode', 'majorCode', 'subjectCode']

const EditExamPositionModal = forwardRef((props, ref) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const [messageApi, messageContextHolder] = message.useMessage()
  const positionDict = useSelector(state => state.positionDict.positionDict)
  const [modalVisible, setModalVisible] = useState(false)
  const [formItems, setFormItems] = useState([])
  const [modalTitle, setModalTitle] = useState('')
  const [modalLoading, setModalLoading] = useState(false)
  const [examClassInfo, setExamClassInfo] = useState([])
  const [notifyApi, contentHolder] = notification.useNotification()
  const [selectedApplySite, setSelectedApplySite] = useState({})

  useEffect(() => {
    if (modalVisible) {
      getPositionTemplate()
      getExamClassAction()
      if (props.modalType === 'create') {
        setModalTitle('新增职位')
      } else {
        setModalTitle('编辑职位')
        form.setFieldsValue({
          ...props.positionItem
        })
        setSelectedApplySite({
          siteNumber: props.positionItem.siteNumber,
          id: props.positionItem.siteId,
          siteCode: props.positionItem.siteCode
        })
      }
    }
  }, [modalVisible])

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const getExamClassAction = () => {
    getExamClass({ examId: props.examInfo.id }).then(res => {
      if (res.code === ResponseCode.success) {
        if (Object.keys(res.data).length > 0) {
          setExamClassInfo(res.data)
        }
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '查询考试科目失败',
        centered: true
      })
    })
  }

  const showModal = () => {
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    form.resetFields()
  }

  const getPositionTemplate = () => {
    getExamPositionTemplate({ id: props.examInfo.id }).then(res => {
      if (res.code === ResponseCode.success) {
        if (res.data.indexTemplateSet) {
          setFormItems(res.data.indexTemplateSet)
        }
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '查询职位字段失败',
        centered: true
      })
    })
  }

  const SelectFormItem = ({ formItem, value, onChange }) => {
    const [options, setOption] = useState([])
    const [selectDisabled, setSelectDisabled] = useState(false)

    const getSelectOptions = (field) => {
      getExamDictData({ dictCode: field }).then(res => {
        if (res.code === ResponseCode.success && res.data) {
          dispatch(updatePositionDic({ dictKey: field, dictValue: res.data }))
        } else {
          Modal.error({
            title: '错误',
            content: res.msg,
            centered: true
          })
        }
      }).catch(() => {
        Modal.error({
          title: '网络错误',
          content: '查询字典数据失败',
          centered: true
        })
      })
    }

    useEffect(() => {
      if (formItem.fieldJoinSelect) {
        if (positionDict[formItem.fieldJoinSelect]) {
          setOption(positionDict[formItem.fieldJoinSelect].map(dict => {
            return {
              label: dict.dictLabel,
              value: dict.dictLabel,
              dictVal: dict.dictValue
            }
          }))
        } else {
          getSelectOptions(formItem.fieldJoinSelect)
        }
      }
    }, [positionDict])

    useEffect(() => {
      if (formItem.examSelection) {
        if (formItem.examSelection === 'site') {
          if (props.modalType === 'edit') {
            setSelectDisabled(false)
          }
          setOption(props.examInfo.applySiteList?.map(site => {
            return {
              label: site.name,
              value: site.name,
              id: site.id,
              siteNumber: site.number,
              siteCode: site.applySiteCode
            }
          }))
        }

        if (formItem.examSelection === 'level') {
          setOption(examClassInfo.map(level => {
            return {
              label: level.levelName,
              value: level.levelName,
              code: level.levelCode
            }
          }))
        }
      }
    }, [])

    const onDropdownVisibleChange = () => {
      if (formItem.examSelection === 'major') {
        const levelCode = form.getFieldValue('levelCode')

        if (levelCode) {
          setOption(examClassInfo.find(level => {
            return level.levelCode === levelCode
          }).majorList.map(major => {
            return {
              label: major.majorName,
              value: major.majorName,
              code: major.majorCode,
              subjectList: major.subjectList
            }
          }))
        } else {
          messageApi.open({
            type: 'error',
            content: '121'
          })
        }
      }
    }

    const onSelect = (key, option) => {
      onChange?.(key, option)
    }

    return (<>
      <Select
        mode={
        ['subjectName', 'subjectCode'].includes(formItem.fieldCode)
          ? 'multiple'
          : false
      }
        value={ value }
        disabled={ selectDisabled }
        options={ options }
        onChange={ onChange }
        onSelect={ onSelect }
        onDropdownVisibleChange={ onDropdownVisibleChange }
      ></Select>
    </>)
  }

  const selectFormChange = (formItem, selectKey, selectItem) => {
    if (formItem.fieldCode === 'siteName' && selectKey) {
      form.setFieldValue('siteCode', selectItem.siteCode)
      form.setFieldValue('siteId', selectItem.id)
      setSelectedApplySite(selectItem)
    }

    if (formItem.fieldCode === 'levelName' && selectKey) {
      form.setFieldValue('levelCode', selectItem.code)
      form.resetFields(['majorName', 'majorCode', 'subjectName', 'subjectCode'])
    }

    if (formItem.fieldCode === 'majorName' && selectKey) {
      form.setFieldValue('majorCode', selectItem.code)
      form.setFieldValue('subjectName', selectItem.subjectList.map(item => item.subjectName))
      form.setFieldValue('subjectCode', selectItem.subjectList.map(item => item.subjectCode))
    }


  }

  const generateFormComponent = (field) => {
    if (field.fieldCode === 'subjectName') {
      return <Input disabled></Input>
    }

    if (field.examSelection) {
      return (
        <SelectFormItem
          formItem={ field }
          onChange={ selectFormChange.bind(this, field) }
        ></SelectFormItem>
      )
    }

    switch (String(field.fieldType)) {
      case positionFieldTypeMap.select:
        return (
          <SelectFormItem
            formItem={ field }
            onChange={ selectFormChange.bind(this, field) }
          ></SelectFormItem>
        )
      case positionFieldTypeMap.textarea:
        return <Input.TextArea placeholder="请输入"></Input.TextArea>
      case positionFieldTypeMap.dateRangePicker:
        return <DatePicker format="YYYY-MM-DD" style={ { width: '100%' } }></DatePicker>
      case positionFieldTypeMap.cascader:
        if (field.fieldJoinSelect) {
          return <TreeDataFormField fieldJoinSelect={ field.fieldJoinSelect }></TreeDataFormField>
        }
        return <RegionFormField></RegionFormField>
      case positionFieldTypeMap.input:
      default:
        return <Input placeholder="请输入"></Input>
    }
  }

  const getFormItem = (formItems) => {
    return formItems.sort((a, b) => {
      return a.fieldSort - b.fieldSort
    }).map((item, index) => {
      if (HIDDEN_POSITION_FIELD_CODES.includes(item.fieldCode)) {
        return null
      }

      return (
        <Col span={ 24 } key={ item.fieldCode || index }>
          <Form.Item
            name={ item.fieldCode }
            label={ item.fieldName }
            rules={ [{ required: true, message: `${ item.fieldName }不能为空` }] }
          >
            { generateFormComponent(item) }
          </Form.Item>
        </Col>
      )
    })
  }

  const getHiddenFormItems = () => {
    return HIDDEN_POSITION_FIELD_CODES.map(fieldCode => {
      return (
        <Form.Item key={ fieldCode } name={ fieldCode } hidden>
          <Input />
        </Form.Item>
      )
    })
  }

  const onOk = () => {
    form.validateFields().then(fields => {
      if (props.modalType === 'create') {
        createExamPositionAction(fields)
      } else {
        updateExamPositionAction(fields)
      }
    })
  }

  const buildPositionPayload = (fields) => {
    return {
      ...fields,
      siteNumber: selectedApplySite.siteNumber ?? props.positionItem?.siteNumber
    }
  }

  const createExamPositionAction = (fields) => {
    const params = {
      examId: props.examInfo.id,
      position: buildPositionPayload(fields)
    }

    createExamPosition(params).then(res => {
      if (res.code === ResponseCode.success) {
        notifyApi.success({
          message: '操作成功'
        })
        hideModal()
        props.insertSuccess && props.insertSuccess()
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '创建职位失败',
        centered: true
      })
    })
  }

  const updateExamPositionAction = (fields) => {
    const params = {
      examId: props.examInfo.id,
      id: props.positionItem._id,
      position: buildPositionPayload(fields)
    }

    updateExamPosition(params).then(res => {
      if (res.code === ResponseCode.success) {
        notifyApi.success({
          message: '操作成功'
        })
        hideModal()
        props.insertSuccess && props.insertSuccess()
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '更新职位失败',
        centered: true
      })
    })
  }

  return (
    <div ref={ ref }>
      { contentHolder }
      { messageContextHolder }
      <Modal
        width={800}
        title={ modalTitle }
        open={ modalVisible }
        onOk={ onOk }
        onCancel={ hideModal }
      >
        <Spin spinning={ modalLoading }>
          <Form
            className="mt-4"
            form={ form }
            labelCol={ {
              span: 4
            } }
            labelWrap={ true }
            wrapperCol={ {
              span: 18
            } }
          >
            <Row gutter={ 20 }>
              { getFormItem(formItems) }
            </Row>
            { getHiddenFormItems() }
          </Form>
        </Spin>
      </Modal>
    </div>
  )
})

export default EditExamPositionModal
